const NOTIFICATION_STRINGS = {
  INVOICE_SAVED: 'Invoice saved.',
  INVOICE_DELETED: 'Invoice deleted.',
  INVOICE_UPDATED: 'Changes saved.',
  DUPLICATE_BUTTON: 'Duplicate',
  PRINT_PDF_BUTTON: 'Download PDF',
  ERROR_TITLE: 'Unable to save Invoice.',
  ERROR_MESSAGE:
    'An error prevented your Invoice from being saved. Please try again.',

  CONTACT_BUTTON: 'Contact Support',
  DOWNLOADING_PDF_MESSAGE: 'Loading PDF...',
  // PDF export error messages
  PDF_ERROR_TITLE: 'Unable to create PDF.',
  PDF_ERROR_MESSAGE:
    'An error prevented your PDF from being created. Please try again.',
  PDF_TRY_AGAIN_BUTTON: 'Try Again',
  // Delete operation messages
  DELETING_INVOICE_MESSAGE: 'Deleting Invoice...',
  DELETE_CONFIRM_TITLE: 'Delete Invoice?',
  DELETE_ERROR_TITLE: 'Unable to delete Invoice.',
  DELETE_ERROR_MESSAGE:
    'An error prevented your Invoice from being deleted. Please try again.'
};

export default NOTIFICATION_STRINGS;
